import React, { useState } from 'react';
import Dashboard from "../../templates/Dashboard"
import Ads from 'Modules/LoyaltyApp/Ads';
import AddAds from 'Modules/LoyaltyApp/Ads/AddAds';
import EditAds from 'Modules/LoyaltyApp/Ads/EditAds';
import Rewards from 'Modules/LoyaltyApp/Rewards';
import AddRewards from 'Modules/LoyaltyApp/Rewards/AddRewards';
import EditRewards from 'Modules/LoyaltyApp/Rewards/EditRewards';

const Components = {
  Ads,
  AddAds,
  EditAds,
  Rewards,
  AddRewards,
  EditRewards,
};

export default (props) => {
  const LoyaltyAppComp = Components[props.Comp];
  const [loading, setLoading] = useState(false);

  return (
    <Dashboard load={loading} setLoading={setLoading}>
      <LoyaltyAppComp loading={loading} setLoading={setLoading} />
    </Dashboard>
  );
};